import { BomLine } from './bom-line';

export class Bom {
  id: string;
  name: string;
  notes: string;
  organizationId: string;
  type: 'MasterBom';
  lines: BomLine[];
  createdBy: string;
  markets: string[];
  errorMessages: string[];

  constructor(data: any = {}) {
    this.name = data.name || '';
    this.notes = data.notes || '';
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/api/models/bom.ts